<template>
  <div class="keyfacts-item">
    <div class="icon">
      <DatoAsset
        v-if="item.icon?.responsiveImage"
        :asset="item.icon"
        class="image"
      />
      <img v-lazy-load 
        v-else-if="isSvgIcon && item.icon"
        :data-src="item.icon.url"
        :alt="item.icon.alt ?? ''"
        class="image -svg"
      />
    </div>
    <h3 class="title">{{ item.title }}</h3>
    <StructuredText class="text rich-text" :data="item.text" />
  </div>
</template>

<script setup lang="ts">
import type { KeyfactItem } from '#gql';
import { StructuredText } from 'vue-datocms';
import DatoAsset from '~/dato/DatoAsset.vue';

const props = defineProps<{
  item: KeyfactItem;
}>();

const isSvgIcon = computed(() => {
  const icon = props.item.icon;
  if (!icon?.url) {
    return false;
  }

  return (
    icon.mimeType === 'image/svg+xml' || icon.url.toLowerCase().includes('.svg')
  );
});
</script>

<style scoped lang="scss">
.keyfacts-item {
  @extend %base-grid;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 'icon title' 'icon text';
  border-top: 1px solid var(--color-light-grey);
  padding-block: 1.5rem 2.5rem;
  row-gap: 0.5rem;

  @media (--vs) {
    grid-template-columns: 1fr;
    grid-template-areas: 'title' 'text' 'icon';
    row-gap: 1rem;
    padding-block: 1rem 1.5rem;
  }

  > .icon {
    grid-area: icon;
    display: flex;

    > .image {
      width: 3.75rem;
      height: 3.7rem;
      aspect-ratio: 1/1;

      @media (--vs) {
        width: 2.5rem;
        height: 2.5rem;
      }

      &.-svg {
        object-fit: contain;
      }
    }
  }

  > .title {
    @include text-md(700);
    grid-area: title;
  }

  > .text {
    grid-area: text;
    text-wrap: wrap;
  }
}
</style>
